var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL SERVICES","title":"Library Management","description":"Manage library books, borrowing, returns, stock and fines.","count-label":"library tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }